import React from 'react';
import { ExportToCSVByDateViewStore } from 'modules/order/stores';
import { ExportToCSVByDateTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ExportToCSVByDateViewStore(rootStore), 'exportToCSVByDateViewStore')
class ExportToCSVByDate extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ExportToCSVByDateTemplate {...this.props} />;
	}
}

export default ExportToCSVByDate;



// WEBPACK FOOTER //
// ./src/modules/order/pages/ExportToCSVByDate.jsx